// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tron-Styled Wallet Modal */
.tron-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: tronFadeIn 0.3s ease-out;
}

@keyframes tronFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.tron-modal {
  position: relative;
  width: 90%;
  max-width: 480px;
  background: linear-gradient(135deg, rgba(0, 20, 40, 0.95), rgba(0, 40, 80, 0.95));
  border-radius: 16px;
  padding: 32px;
  box-shadow: 
    0 0 60px rgba(0, 255, 255, 0.3),
    0 0 120px rgba(0, 255, 255, 0.15),
    inset 0 0 40px rgba(0, 255, 255, 0.05);
  animation: tronSlideUp 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes tronSlideUp {
  from {
    transform: translateY(60px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Animated Borders */
.tron-border {
  position: absolute;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(0, 255, 255, 0.8) 50%, 
    transparent 100%
  );
  animation: tronBorderPulse 3s ease-in-out infinite;
}

.tron-border-top {
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  animation-delay: 0s;
}

.tron-border-right {
  top: 0;
  right: 0;
  bottom: 0;
  width: 2px;
  animation-delay: 0.75s;
}

.tron-border-bottom {
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  animation-delay: 1.5s;
}

.tron-border-left {
  top: 0;
  left: 0;
  bottom: 0;
  width: 2px;
  animation-delay: 2.25s;
}

@keyframes tronBorderPulse {
  0%, 100% {
    opacity: 0.4;
    box-shadow: 0 0 10px rgba(0, 255, 255, 0.3);
  }
  50% {
    opacity: 1;
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.8);
  }
}

/* Header */
.tron-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(0, 255, 255, 0.2);
  padding-bottom: 16px;
}

.tron-title {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 3px;
  color: #00ffff;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
  display: flex;
  align-items: center;
  gap: 12px;
}

.tron-admin-badge {
  font-size: 12px;
  letter-spacing: 2px;
  padding: 4px 12px;
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.2), rgba(255, 140, 0, 0.2));
  border: 1px solid rgba(255, 215, 0, 0.6);
  border-radius: 4px;
  color: #ffd700;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
  animation: adminPulse 2s ease-in-out infinite;
}

@keyframes adminPulse {
  0%, 100% {
    box-shadow: 0 0 10px rgba(255, 215, 0, 0.3);
  }
  50% {
    box-shadow: 0 0 20px rgba(255, 215, 0, 0.6);
  }
}

.tron-close {
  background: transparent;
  border: 1px solid rgba(0, 255, 255, 0.3);
  color: #00ffff;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
  transition: all 0.2s ease;
}

.tron-close:hover {
  background: rgba(0, 255, 255, 0.1);
  border-color: #00ffff;
  box-shadow: 0 0 15px rgba(0, 255, 255, 0.4);
}

/* Body */
.tron-modal-body {
  margin-bottom: 24px;
}

/* Wallet Address */
.tron-wallet-address {
  background: rgba(0, 255, 255, 0.05);
  border: 1px solid rgba(0, 255, 255, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
}

.tron-label {
  font-size: 10px;
  letter-spacing: 2px;
  color: rgba(0, 255, 255, 0.7);
  margin-bottom: 6px;
}

.tron-address-value {
  font-family: 'Courier New', monospace;
  font-size: 16px;
  color: #00ffff;
  text-shadow: 0 0 8px rgba(0, 255, 255, 0.4);
}

/* Student Name */
.tron-student-name {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 0 15px rgba(0, 255, 255, 0.6);
  margin-bottom: 20px;
  letter-spacing: 1px;
}

/* Stats Grid */
.tron-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.tron-stat-card {
  background: rgba(0, 40, 80, 0.4);
  border: 1px solid rgba(0, 255, 255, 0.2);
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  transition: all 0.3s ease;
}

.tron-stat-card:hover {
  background: rgba(0, 60, 120, 0.4);
  border-color: rgba(0, 255, 255, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 255, 255, 0.2);
}

.tron-stat-card.tron-highlight {
  background: rgba(0, 255, 255, 0.08);
  border-color: rgba(0, 255, 255, 0.4);
}

.tron-stat-icon {
  font-size: 28px;
  margin-bottom: 8px;
  filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.4));
}

.tron-stat-label {
  font-size: 10px;
  letter-spacing: 1.5px;
  color: rgba(0, 255, 255, 0.7);
  margin-bottom: 4px;
}

.tron-stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}

.tron-stripe {
  font-size: 14px;
  color: #ffd700;
  margin-left: 4px;
}

/* Membership Status */
.tron-membership {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(0, 255, 255, 0.05);
  border: 1px solid rgba(0, 255, 255, 0.2);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.tron-membership.active {
  background: rgba(0, 255, 100, 0.08);
  border-color: rgba(0, 255, 100, 0.4);
}

.tron-membership.trial {
  background: rgba(255, 150, 0, 0.08);
  border-color: rgba(255, 150, 0, 0.4);
}

.tron-membership-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(0, 255, 255, 0.1);
  border: 2px solid rgba(0, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #00ffff;
}

.tron-membership.active .tron-membership-icon {
  background: rgba(0, 255, 100, 0.15);
  border-color: #00ff64;
  color: #00ff64;
}

.tron-membership.trial .tron-membership-icon {
  background: rgba(255, 150, 0, 0.15);
  border-color: #ff9600;
  color: #ff9600;
}

.tron-membership-text {
  flex: 1 1;
}

.tron-membership-label {
  font-size: 10px;
  letter-spacing: 2px;
  color: rgba(0, 255, 255, 0.7);
  margin-bottom: 4px;
}

.tron-membership-type {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}

.tron-membership.active .tron-membership-type {
  color: #00ff64;
  text-shadow: 0 0 10px rgba(0, 255, 100, 0.5);
}

.tron-membership.trial .tron-membership-type {
  color: #ff9600;
  text-shadow: 0 0 10px rgba(255, 150, 0, 0.5);
}

/* Footer */
.tron-modal-footer {
  display: flex;
  gap: 12px;
}

.tron-btn {
  flex: 1 1;
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  outline: none;
}

.tron-btn-secondary {
  background: rgba(255, 50, 50, 0.1);
  border: 1px solid rgba(255, 50, 50, 0.4);
  color: #ff5050;
}

.tron-btn-secondary:hover {
  background: rgba(255, 50, 50, 0.2);
  border-color: #ff5050;
  box-shadow: 0 0 20px rgba(255, 50, 50, 0.3);
  transform: translateY(-2px);
}

.tron-btn-primary {
  background: linear-gradient(135deg, rgba(0, 255, 255, 0.2), rgba(0, 180, 255, 0.2));
  border: 1px solid rgba(0, 255, 255, 0.6);
  color: #00ffff;
  box-shadow: 0 0 20px rgba(0, 255, 255, 0.2);
}

.tron-btn-primary:hover {
  background: linear-gradient(135deg, rgba(0, 255, 255, 0.3), rgba(0, 180, 255, 0.3));
  border-color: #00ffff;
  box-shadow: 0 0 30px rgba(0, 255, 255, 0.4);
  transform: translateY(-2px);
}

/* Loading State */
.tron-loading {
  text-align: center;
  padding: 40px 20px;
}

.tron-spinner {
  width: 60px;
  height: 60px;
  border: 3px solid rgba(0, 255, 255, 0.1);
  border-top-color: #00ffff;
  border-radius: 50%;
  margin: 0 auto 20px;
  animation: tronSpin 1s linear infinite;
}

@keyframes tronSpin {
  to {
    transform: rotate(360deg);
  }
}

.tron-loading p {
  color: #00ffff;
  font-size: 14px;
  letter-spacing: 2px;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}

/* Mobile Responsive */
@media (max-width: 640px) {
  .tron-modal {
    width: 95%;
    padding: 24px;
    max-height: 90vh;
    overflow-y: auto;
  }

  .tron-student-name {
    font-size: 20px;
  }

  .tron-stats-grid {
    grid-template-columns: 1fr;
  }

  .tron-modal-footer {
    flex-direction: column;
  }

  .tron-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TronWalletModal.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,iFAAiF;EACjF,mBAAmB;EACnB,aAAa;EACb;;;0CAGwC;EACxC,0DAA0D;AAC5D;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB;;;;GAIC;EACD,kDAAkD;AACpD;;AAEA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;IACZ,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,2CAA2C;EAC7C;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mFAAmF;EACnF,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4CAA4C;EAC5C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,mFAAmF;EACnF,wCAAwC;EACxC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,mFAAmF;EACnF,qBAAqB;EACrB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Tron-Styled Wallet Modal */\n.tron-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(12px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: tronFadeIn 0.3s ease-out;\n}\n\n@keyframes tronFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.tron-modal {\n  position: relative;\n  width: 90%;\n  max-width: 480px;\n  background: linear-gradient(135deg, rgba(0, 20, 40, 0.95), rgba(0, 40, 80, 0.95));\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: \n    0 0 60px rgba(0, 255, 255, 0.3),\n    0 0 120px rgba(0, 255, 255, 0.15),\n    inset 0 0 40px rgba(0, 255, 255, 0.05);\n  animation: tronSlideUp 0.4s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes tronSlideUp {\n  from {\n    transform: translateY(60px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Animated Borders */\n.tron-border {\n  position: absolute;\n  background: linear-gradient(90deg, \n    transparent 0%, \n    rgba(0, 255, 255, 0.8) 50%, \n    transparent 100%\n  );\n  animation: tronBorderPulse 3s ease-in-out infinite;\n}\n\n.tron-border-top {\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  animation-delay: 0s;\n}\n\n.tron-border-right {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 2px;\n  animation-delay: 0.75s;\n}\n\n.tron-border-bottom {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  animation-delay: 1.5s;\n}\n\n.tron-border-left {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 2px;\n  animation-delay: 2.25s;\n}\n\n@keyframes tronBorderPulse {\n  0%, 100% {\n    opacity: 0.4;\n    box-shadow: 0 0 10px rgba(0, 255, 255, 0.3);\n  }\n  50% {\n    opacity: 1;\n    box-shadow: 0 0 20px rgba(0, 255, 255, 0.8);\n  }\n}\n\n/* Header */\n.tron-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  border-bottom: 1px solid rgba(0, 255, 255, 0.2);\n  padding-bottom: 16px;\n}\n\n.tron-title {\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: 3px;\n  color: #00ffff;\n  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.tron-admin-badge {\n  font-size: 12px;\n  letter-spacing: 2px;\n  padding: 4px 12px;\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.2), rgba(255, 140, 0, 0.2));\n  border: 1px solid rgba(255, 215, 0, 0.6);\n  border-radius: 4px;\n  color: #ffd700;\n  text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);\n  animation: adminPulse 2s ease-in-out infinite;\n}\n\n@keyframes adminPulse {\n  0%, 100% {\n    box-shadow: 0 0 10px rgba(255, 215, 0, 0.3);\n  }\n  50% {\n    box-shadow: 0 0 20px rgba(255, 215, 0, 0.6);\n  }\n}\n\n.tron-close {\n  background: transparent;\n  border: 1px solid rgba(0, 255, 255, 0.3);\n  color: #00ffff;\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 18px;\n  transition: all 0.2s ease;\n}\n\n.tron-close:hover {\n  background: rgba(0, 255, 255, 0.1);\n  border-color: #00ffff;\n  box-shadow: 0 0 15px rgba(0, 255, 255, 0.4);\n}\n\n/* Body */\n.tron-modal-body {\n  margin-bottom: 24px;\n}\n\n/* Wallet Address */\n.tron-wallet-address {\n  background: rgba(0, 255, 255, 0.05);\n  border: 1px solid rgba(0, 255, 255, 0.2);\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n}\n\n.tron-label {\n  font-size: 10px;\n  letter-spacing: 2px;\n  color: rgba(0, 255, 255, 0.7);\n  margin-bottom: 6px;\n}\n\n.tron-address-value {\n  font-family: 'Courier New', monospace;\n  font-size: 16px;\n  color: #00ffff;\n  text-shadow: 0 0 8px rgba(0, 255, 255, 0.4);\n}\n\n/* Student Name */\n.tron-student-name {\n  text-align: center;\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  text-shadow: 0 0 15px rgba(0, 255, 255, 0.6);\n  margin-bottom: 20px;\n  letter-spacing: 1px;\n}\n\n/* Stats Grid */\n.tron-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.tron-stat-card {\n  background: rgba(0, 40, 80, 0.4);\n  border: 1px solid rgba(0, 255, 255, 0.2);\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.tron-stat-card:hover {\n  background: rgba(0, 60, 120, 0.4);\n  border-color: rgba(0, 255, 255, 0.4);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(0, 255, 255, 0.2);\n}\n\n.tron-stat-card.tron-highlight {\n  background: rgba(0, 255, 255, 0.08);\n  border-color: rgba(0, 255, 255, 0.4);\n}\n\n.tron-stat-icon {\n  font-size: 28px;\n  margin-bottom: 8px;\n  filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.4));\n}\n\n.tron-stat-label {\n  font-size: 10px;\n  letter-spacing: 1.5px;\n  color: rgba(0, 255, 255, 0.7);\n  margin-bottom: 4px;\n}\n\n.tron-stat-value {\n  font-size: 22px;\n  font-weight: 700;\n  color: #ffffff;\n  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);\n}\n\n.tron-stripe {\n  font-size: 14px;\n  color: #ffd700;\n  margin-left: 4px;\n}\n\n/* Membership Status */\n.tron-membership {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: rgba(0, 255, 255, 0.05);\n  border: 1px solid rgba(0, 255, 255, 0.2);\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n}\n\n.tron-membership.active {\n  background: rgba(0, 255, 100, 0.08);\n  border-color: rgba(0, 255, 100, 0.4);\n}\n\n.tron-membership.trial {\n  background: rgba(255, 150, 0, 0.08);\n  border-color: rgba(255, 150, 0, 0.4);\n}\n\n.tron-membership-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: rgba(0, 255, 255, 0.1);\n  border: 2px solid rgba(0, 255, 255, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  color: #00ffff;\n}\n\n.tron-membership.active .tron-membership-icon {\n  background: rgba(0, 255, 100, 0.15);\n  border-color: #00ff64;\n  color: #00ff64;\n}\n\n.tron-membership.trial .tron-membership-icon {\n  background: rgba(255, 150, 0, 0.15);\n  border-color: #ff9600;\n  color: #ff9600;\n}\n\n.tron-membership-text {\n  flex: 1;\n}\n\n.tron-membership-label {\n  font-size: 10px;\n  letter-spacing: 2px;\n  color: rgba(0, 255, 255, 0.7);\n  margin-bottom: 4px;\n}\n\n.tron-membership-type {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);\n}\n\n.tron-membership.active .tron-membership-type {\n  color: #00ff64;\n  text-shadow: 0 0 10px rgba(0, 255, 100, 0.5);\n}\n\n.tron-membership.trial .tron-membership-type {\n  color: #ff9600;\n  text-shadow: 0 0 10px rgba(255, 150, 0, 0.5);\n}\n\n/* Footer */\n.tron-modal-footer {\n  display: flex;\n  gap: 12px;\n}\n\n.tron-btn {\n  flex: 1;\n  padding: 14px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 2px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  outline: none;\n}\n\n.tron-btn-secondary {\n  background: rgba(255, 50, 50, 0.1);\n  border: 1px solid rgba(255, 50, 50, 0.4);\n  color: #ff5050;\n}\n\n.tron-btn-secondary:hover {\n  background: rgba(255, 50, 50, 0.2);\n  border-color: #ff5050;\n  box-shadow: 0 0 20px rgba(255, 50, 50, 0.3);\n  transform: translateY(-2px);\n}\n\n.tron-btn-primary {\n  background: linear-gradient(135deg, rgba(0, 255, 255, 0.2), rgba(0, 180, 255, 0.2));\n  border: 1px solid rgba(0, 255, 255, 0.6);\n  color: #00ffff;\n  box-shadow: 0 0 20px rgba(0, 255, 255, 0.2);\n}\n\n.tron-btn-primary:hover {\n  background: linear-gradient(135deg, rgba(0, 255, 255, 0.3), rgba(0, 180, 255, 0.3));\n  border-color: #00ffff;\n  box-shadow: 0 0 30px rgba(0, 255, 255, 0.4);\n  transform: translateY(-2px);\n}\n\n/* Loading State */\n.tron-loading {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.tron-spinner {\n  width: 60px;\n  height: 60px;\n  border: 3px solid rgba(0, 255, 255, 0.1);\n  border-top-color: #00ffff;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n  animation: tronSpin 1s linear infinite;\n}\n\n@keyframes tronSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.tron-loading p {\n  color: #00ffff;\n  font-size: 14px;\n  letter-spacing: 2px;\n  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);\n}\n\n/* Mobile Responsive */\n@media (max-width: 640px) {\n  .tron-modal {\n    width: 95%;\n    padding: 24px;\n    max-height: 90vh;\n    overflow-y: auto;\n  }\n\n  .tron-student-name {\n    font-size: 20px;\n  }\n\n  .tron-stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .tron-modal-footer {\n    flex-direction: column;\n  }\n\n  .tron-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
